export const DUPLO_TOP_MAIN_GROUP = '1';

export const isDuploTopMainGroup = (mainGroupTop: string | undefined): boolean =>
  mainGroupTop === DUPLO_TOP_MAIN_GROUP;
